<div class="new-help-modal">
  <div class="title-wrap">
    <span>Need Some Help?</span>
    <button (click)="closeDetail()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  @if (warningMessage && !!warningMessage.description) {
    <div class="issue-container">
      <span class="warning-description">
        {{ warningMessage.description }}
        @if (warningMessage?.link?.url) {
          <a [href]="warningMessage?.link?.url" target="_blank">{{ warningMessage?.link?.text }}</a>
        }
      </span>
    </div>
  }
  <div class="content-text">
    Here are some links to FAQ’s If you have other questions, go to our help center or submit a support ticket
  </div>
  <div class="section-divider"></div>
  <div class="help-link-wrapper">
    <span>Quick Links</span>
    <div class="links-wrapper">
      <button (click)="showTutorialView()">How to move</button>
      <button (click)="showExperienceTipsView()">Tips for a great experience</button>
      <button id="btnCustomClicked" (click)="submitTicket()">Submit a support ticket</button>
    </div>
  </div>
  <div class="section-divider"></div>
  <div class="footer-dialog">
    <button class="cancel-button" (click)="closeDetail()">Cancel</button>
    <button
      id="socialHelpModalPrimaryButton"
      data-testid="social-modal-primary-button"
      (click)="goToHelpCenter()"
      class="go-to-support-button"
    >
      Go to support center
    </button>
  </div>
</div>

@if (showTutorial) {
  <room-tutorial
    (completeEvent)="onTutorialCompleted()"
    [title]="tutorialTitle"
    [showSkip]="tutorialType === 0"
    [cards]="tutorialCards"
    [type]="tutorialType"
  />
}
